import React from 'react';
import FmsMap from '../components/Map/FmsMap';

const Distance = () => {
  return (
    <div>
      <FmsMap title="Distance & Route Calculator" />
    </div>
  );
};

export default Distance;
